"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const fees_1 = require("../../fees");
const address_1 = __importDefault(require("../../address"));
class PartnerBilling {
    constructor(name, email, differentBillingAddress, invoiceFrequecy, periodEnding, commissionPercentage = 0, chargeBrokerServiceFee, brokerServiceFee, ccEmail, address) {
        this.name = name;
        this.email = email;
        this.differentBillingAddress = differentBillingAddress;
        this.invoiceFrequecy = invoiceFrequecy;
        this.periodEnding = periodEnding;
        this.commissionPercentage = commissionPercentage;
        this.chargeBrokerServiceFee = chargeBrokerServiceFee;
        this.brokerServiceFee = brokerServiceFee;
        this.ccEmail = ccEmail;
        this.address = address;
    }
    static fromObj(data, partnerId, currency) {
        var _a;
        const fee = data.brokerServiceFee
            ? fees_1.feeComponentFromObj(Object.assign(Object.assign({}, data.brokerServiceFee), { id: partnerId, currency }))
            : undefined;
        return new PartnerBilling(data.name, data.email, !!data.differentBillingAddress, "Monthly", "LastDay", Number((_a = data.commissionPercentage) !== null && _a !== void 0 ? _a : 0), !!data.chargeBrokerServiceFee, fee, data.ccEmail, data.address ? address_1.default.fromObj(data.address) : undefined);
    }
    static fromParentBilling(parentBilling) {
        return new PartnerBilling(parentBilling.name, parentBilling.email, !!parentBilling.differentBillingAddress, "Monthly", "LastDay", 0, false, undefined, parentBilling.ccEmail, parentBilling.address);
    }
}
exports.default = PartnerBilling;
//# sourceMappingURL=partnerBilling.class.js.map